    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner></mat-spinner>
    </div>
